<template>
  <AuthLayout>
    <Head>
      <title>Login</title>
    </Head>

    <div class="px-4 py-5 sm:p-6">
      <form class="sm:gap-4 sm:flex sm:flex-col sm:items-start sm:justify-between" @submit.prevent="submit">
        <FormInput name="email"
                   :errors="errors"
                   v-model="form.email"
                   autofocus
                   class="w-full" />

        <FormInput name="password"
                   :errors="errors"
                   v-model="form.password"
                   type="password"
                   class="w-full" />

        <div class="sm:flex sm:place-items-end w-full sm:place-content-end -mt-5">
          <FormActions :show-cancel="false" submit-label="Login" />
        </div>
      </form>
    </div>
  </AuthLayout>
</template>

<script>
import AuthLayout from '@/layouts/auth.vue'
import PageComponent from '@/pages/page-component'
import FormComponent from '@/pages/form-component'
import { Inertia } from '@inertiajs/inertia'

export default {
  mixins: [
    PageComponent,
    FormComponent,
  ],

  components: {
    AuthLayout,
  },

  props: ['errors'],

  data() {
    return {
      form: {
        email: null,
        password: null,
      },
    }
  },

  methods: {
    submit() {
      Inertia.post('/login', this.form)
    }
  }
}
</script>
